"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Upgrader;
    }
});
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("./cache/NocoCache"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _metaservice = require("~/meta/meta.service");
const _globals = require("~/utils/globals");
const _catchError = require("~/helpers/catchError");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const BATCH_SIZE = 500;
let Upgrader = class Upgrader extends _metaservice.MetaService {
    get upgrader_mode() {
        return this._upgrader_mode;
    }
    get upgrader_queries() {
        return this._upgrader_queries;
    }
    async metaInsert2(workspace_id, base_id, target, data, ignoreIdGeneration) {
        if (!this._upgrader_mode) throw new Error('Upgrader mode is not enabled');
        const insertObj = _extends({}, data, ignoreIdGeneration ? {} : {
            id: (data == null ? void 0 : data.id) || await this.genNanoid(target)
        });
        if (workspace_id === base_id) {
            if (!Object.values(_globals.RootScopes).includes(workspace_id)) {
                _catchError.NcError.metaError({
                    message: 'Invalid scope',
                    sql: ''
                });
            }
            if (!_globals.RootScopeTables[workspace_id].includes(target)) {
                _catchError.NcError.metaError({
                    message: 'Table not accessible from this scope',
                    sql: ''
                });
            }
        } else {
            if (!workspace_id) {
                _catchError.NcError.metaError({
                    message: 'Workspace ID is required',
                    sql: ''
                });
            }
            insertObj.fk_workspace_id = workspace_id;
            if (!base_id && base_id !== _globals.RootScopes.WORKSPACE) {
                _catchError.NcError.metaError({
                    message: 'Base ID is required',
                    sql: ''
                });
            }
            if (base_id !== _globals.RootScopes.WORKSPACE) insertObj.base_id = base_id;
        }
        const qb = this.knexConnection(target).insert(_extends({}, insertObj, {
            created_at: this.now(),
            updated_at: this.now()
        }));
        this.logHelper(workspace_id, base_id, target, qb);
        if (this._upgrader_mode === true) {
            await this.pushUpgraderQuery(qb.toQuery());
            return insertObj;
        }
        await qb;
        return insertObj;
    }
    async bulkMetaInsert(workspace_id, base_id, target, data, ignoreIdGeneration) {
        if (!this._upgrader_mode) throw new Error('Upgrader mode is not enabled');
        if (Array.isArray(data) ? !data.length : !data) {
            return [];
        }
        const insertObj = [];
        const at = this.now();
        const commonProps = {
            created_at: at,
            updated_at: at
        };
        if (workspace_id === base_id) {
            if (!Object.values(_globals.RootScopes).includes(workspace_id)) {
                _catchError.NcError.metaError({
                    message: 'Invalid scope',
                    sql: ''
                });
            }
            if (!_globals.RootScopeTables[workspace_id].includes(target)) {
                _catchError.NcError.metaError({
                    message: 'Table not accessible from this scope',
                    sql: ''
                });
            }
        } else {
            if (!workspace_id) {
                _catchError.NcError.metaError({
                    message: 'Workspace ID is required',
                    sql: ''
                });
            }
            if (!base_id) {
                _catchError.NcError.metaError({
                    message: 'Base ID is required',
                    sql: ''
                });
            }
            commonProps.fk_workspace_id = workspace_id;
            commonProps.base_id = base_id;
        }
        for (const d of Array.isArray(data) ? data : [
            data
        ]){
            const id = (d == null ? void 0 : d.id) || await this.genNanoid(target);
            const tempObj = _extends({}, d, ignoreIdGeneration ? {} : {
                id
            }, commonProps);
            insertObj.push(tempObj);
        }
        if (this._upgrader_mode === true) {
            await this.pushUpgraderQuery(insertObj.map((d)=>this.knexConnection(target).insert(d).toQuery()));
            return insertObj;
        }
        await this.knexConnection.batchInsert(target, insertObj);
        return insertObj;
    }
    async bulkMetaUpdate(workspace_id, base_id, target, data, ids, condition) {
        if (!this._upgrader_mode) throw new Error('Upgrader mode is not enabled');
        if (Array.isArray(data) ? !data.length : !data) {
            return [];
        }
        const query = this.knexConnection(target);
        const at = this.now();
        if (workspace_id === base_id) {
            if (!Object.values(_globals.RootScopes).includes(workspace_id)) {
                _catchError.NcError.metaError({
                    message: 'Invalid scope',
                    sql: ''
                });
            }
            if (!_globals.RootScopeTables[workspace_id].includes(target)) {
                _catchError.NcError.metaError({
                    message: 'Table not accessible from this scope',
                    sql: ''
                });
            }
        } else {
            if (!workspace_id) {
                _catchError.NcError.metaError({
                    message: 'Workspace ID is required',
                    sql: ''
                });
            }
            if (!base_id) {
                _catchError.NcError.metaError({
                    message: 'Base ID is required',
                    sql: ''
                });
            }
        }
        const updateObj = _extends({}, data, {
            updated_at: at
        });
        if (!condition) {
            query.whereIn('id', ids).update(updateObj);
        } else {
            if (![
                _globals.MetaTable.FILE_REFERENCES
            ].includes(target)) {
                _catchError.NcError.metaError({
                    message: 'This table does not support conditional bulk update',
                    sql: ''
                });
            }
            query.where(condition);
            // Check if a condition is present in the query builder and throw an error if not.
            this.checkConditionPresent(query, 'update');
            query.update(updateObj);
        }
        this.contextCondition(query, workspace_id, base_id, target);
        if (this._upgrader_mode === true) {
            await this.pushUpgraderQuery(query.toQuery());
            return null;
        }
        return query;
    }
    async metaDelete(workspace_id, base_id, target, idOrCondition, xcCondition, force = false) {
        if (!this._upgrader_mode) throw new Error('Upgrader mode is not enabled');
        const query = this.knexConnection(target);
        if (workspace_id === base_id) {
            if (!Object.values(_globals.RootScopes).includes(workspace_id)) {
                _catchError.NcError.metaError({
                    message: 'Invalid scope',
                    sql: ''
                });
            }
            if (!_globals.RootScopeTables[workspace_id].includes(target)) {
                _catchError.NcError.metaError({
                    message: 'Table not accessible from this scope',
                    sql: ''
                });
            }
        } else {
            if (!workspace_id) {
                _catchError.NcError.metaError({
                    message: 'Workspace ID is required',
                    sql: ''
                });
            }
            if (!base_id && base_id !== _globals.RootScopes.WORKSPACE) {
                _catchError.NcError.metaError({
                    message: 'Base ID is required',
                    sql: ''
                });
            }
        }
        if (typeof idOrCondition !== 'object') {
            query.where('id', idOrCondition);
        } else if (idOrCondition) {
            query.where(idOrCondition);
        }
        if (xcCondition) {
            query.condition(xcCondition, {});
        }
        // Check if a condition is present in the query builder and throw an error if not.
        if (!force) {
            this.checkConditionPresent(query, 'delete');
        }
        // Apply context condition
        this.contextCondition(query, workspace_id, base_id, target);
        this.logHelper(workspace_id, base_id, target, query);
        if (this._upgrader_mode === true) {
            await this.pushUpgraderQuery(query.del().toQuery());
            return;
        }
        return query.del();
    }
    async metaUpdate(workspace_id, base_id, target, data, idOrCondition, xcCondition, skipUpdatedAt = false, force = false) {
        if (!this._upgrader_mode) throw new Error('Upgrader mode is not enabled');
        const query = this.knexConnection(target);
        if (workspace_id === base_id) {
            if (!Object.values(_globals.RootScopes).includes(workspace_id)) {
                _catchError.NcError.metaError({
                    message: 'Invalid scope',
                    sql: ''
                });
            }
            if (!_globals.RootScopeTables[workspace_id].includes(target)) {
                _catchError.NcError.metaError({
                    message: 'Table not accessible from this scope',
                    sql: ''
                });
            }
        } else {
            if (!workspace_id) {
                _catchError.NcError.metaError({
                    message: 'Workspace ID is required',
                    sql: ''
                });
            }
            if (!base_id) {
                _catchError.NcError.metaError({
                    message: 'Base ID is required',
                    sql: ''
                });
            }
        }
        delete data.created_at;
        if (!skipUpdatedAt) {
            data.updated_at = this.now();
        }
        query.update(data);
        if (typeof idOrCondition !== 'object') {
            query.where('id', idOrCondition);
        } else if (idOrCondition) {
            query.where(idOrCondition);
        }
        if (xcCondition) {
            query.condition(xcCondition);
        }
        // Check if a condition is present in the query builder and throw an error if not.
        if (!force) {
            this.checkConditionPresent(query, 'update');
        }
        // Apply context condition
        this.contextCondition(query, workspace_id, base_id, target);
        this.logHelper(workspace_id, base_id, target, query);
        if (this._upgrader_mode === true) {
            await this.pushUpgraderQuery(query.toQuery());
            return null;
        }
        return await query;
    }
    enableUpgraderMode() {
        _NocoCache.default.disableCache();
        this._upgrader_mode = true;
    }
    async disableUpgraderMode() {
        _NocoCache.default.enableCache();
        await _NocoCache.default.destroy();
        this._upgrader_mode = false;
    }
    async pushUpgraderQuery(query) {
        if (Array.isArray(query)) {
            this._upgrader_queries.push(...query);
        } else {
            this._upgrader_queries.push(query);
        }
    }
    async runUpgraderQueries() {
        if (!this._upgrader_mode) throw new Error('Upgrader mode is not enabled');
        const queries = this._upgrader_queries.splice(0, BATCH_SIZE);
        if (!queries.length) return [];
        const trans = await this.knexConnection.transaction();
        try {
            for (const query of queries){
                await trans.raw(query);
            }
            await trans.commit();
        } catch (e) {
            await trans.rollback();
            throw e;
        }
    }
    async logHelper(_workspace_id, _base_id, _target, _q) {}
    constructor(){
        const ncMeta = _Noco.default.ncMeta;
        super(ncMeta.config, ncMeta.knex), this._upgrader_queries = [];
    }
};
